//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconRatingThumbsDown(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2 10.6V14C2 14.7956 2.31607 15.5587 2.87868 16.1213C3.44129 16.6839 4.20435 17 5 17H9V20C9 20.5304 9.21071 21.0391 9.58578 21.4142C9.96086 21.7893 10.4696 22 11 22H12.43L18 15.36V8H16V14.64L11.5 20H11V15H5C4.73478 15 4.48043 14.8946 4.29289 14.7071C4.10536 14.5196 4 14.2652 4 14V11.32L8.47 6H18V4H7.53L2 10.6ZM20 4V15H22V4H20Z" fill="currentColor" /></svg>;
}
export default IconRatingThumbsDown;